module.exports = __webpack_public_path__ + "tenant-dashboard.5449c45cdcb92995beb515a7808bef01.hashedasset.svg";